'use client'

import IconMoreAction from '@/components/assets/icon_more_action.svg'
import PopoverMenu from '@/components/PopoverMenu'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import ViverseIconButton from '@/components/ViverseIconButton'
import { useAuthContext } from '@/context/AuthContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { cn } from '@/lib/utils'
import { Comment } from '@/types/comments'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { useIsClient } from 'usehooks-ts'

type CommentMoreActionsButtonProps = {
  comment: Comment
  handleDelete: () => void
  handleReport: () => void
}

function CommentMoreActionsButton({
  comment,
  handleDelete,
  handleReport,
}: CommentMoreActionsButtonProps) {
  const t = useTranslations()
  const { isSignedIn } = useAuthContext()
  const { store } = useConfigsContext()
  const [open, setOpen] = useState(false)
  const isClient = useIsClient()
  const isMyComment = comment.owner.id === store?.profile?.id

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <ViverseIconButton
            size="S"
            variant="empty"
            className={cn(open && 'bg-vive-primary-60')}
            disabled={!isClient || !isSignedIn}
          >
            <IconMoreAction
              width={20}
              height={20}
              className={cn(
                'fill-vive-primary-20 group-hover:fill-vive-white group-active:fill-vive-brand-50',
                open && 'fill-vive-brand-50 group-hover:fill-vive-brand-50',
              )}
            />
          </ViverseIconButton>
        </PopoverTrigger>
        <PopoverContent side="bottom" align="end" className="mt-2 border-none bg-transparent p-0">
          <PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2">
            <PopoverMenu.Group>
              {isSignedIn && !isMyComment && (
                <PopoverMenu.Item
                  className="rounded-none"
                  onClick={() => {
                    handleReport()
                    setOpen(false)
                  }}
                >
                  <div className="body-1 text-inherit">{t('comment-more-action.report')}</div>
                </PopoverMenu.Item>
              )}
              {isMyComment && (
                <PopoverMenu.Item
                  className="rounded-none"
                  onClick={() => {
                    handleDelete()
                    setOpen(false)
                  }}
                >
                  <div className="body-1 text-inherit">{t('comment-more-action.delete')}</div>
                </PopoverMenu.Item>
              )}
            </PopoverMenu.Group>
          </PopoverMenu>
        </PopoverContent>
      </Popover>
    </>
  )
}

export default CommentMoreActionsButton
